import { useState } from 'react';
import TabbedContainer from '../../components/TabbedContainer/TabbedContainer';
import './ElectionData.css';
import Select from 'react-select';
import { useParams } from "react-router-dom";

const ELECTION_RESULTS_DESKTOP_URL = "https://app.powerbigov.us/view?r=eyJrIjoiZjdhNGY0MjAtMWRiZS00YTYyLTgyY2UtNGY2MzkzODU4MGZmIiwidCI6IjZhNjJmY2QyLTJlYzgtNDRlYi1hYWM1LTg4OTJhOGQ1YTgyNiJ9";
const ELECTION_RESULTS_MOBILE_URL = "https://app.powerbigov.us/view?r=eyJrIjoiN2U3NzcyYTgtOWUwNS00NzQ1LTk5NDktMjQwZjA5ZDY0MjZlIiwidCI6IjZhNjJmY2QyLTJlYzgtNDRlYi1hYWM1LTg4OTJhOGQ1YTgyNiJ9";


const ABSENTEE_DESKTOP_URL = "https://app.powerbigov.us/view?r=eyJrIjoiNjllMTAwNGUtM2NiOS00MWIxLWIyM2MtYjNkODBmNGFmZGI0IiwidCI6IjZhNjJmY2QyLTJlYzgtNDRlYi1hYWM1LTg4OTJhOGQ1YTgyNiJ9";
const ABSENTEE_MOBILE_URL = "https://app.powerbigov.us/view?r=eyJrIjoiNzdiN2RkNGUtN2MzOC00Zjc5LTk5OTItZmRiNTUwMmNkMmU5IiwidCI6IjZhNjJmY2QyLTJlYzgtNDRlYi1hYWM1LTg4OTJhOGQ1YTgyNiJ9";


const electionTabs = [
  {
    label: 'Ohio Election Results Data',
    content: (isMobile) => (
      <div className="tab-flex">
        <div className="tab-text">
          <p>The Office of Data Analytics and Archives custom-built the Election Results Data
            Dashboard to provide Ohioans with a user-friendly digital platform for analyzing
            recent election results and trends. In addition to statewide data, this dashboard
            displays county-level data from Ohio’s 88 county boards of elections since the 2016
            Primary Election. The dashboard is updated when the Ohio Secretary of State and
            Ohio’s 88 county boards of elections certify the final results following an election.</p>
          <p>Note: Election Night results will be posted and updated using the Ohio Secretary of State’s 
            {" "}<a href="https://liveresults.ohiosos.gov" target="_blank" rel="noopener noreferrer">Live Results</a>{" "}page. 
            Once the election has been certified by the Secretary of State, the results are moved to the Elections Results Dashboards and to 
            {" "}<a href="https://data.ohiosos.gov/portal/past-election-results" target="_blank" rel="noopener noreferrer">Past Election Results</a>{" "}page.</p>
          <p>The dashboard is best displayed and navigated on a desktop computer. If you have questions,
            suggestions, or experience issues while utilizing the Election Results Data Dashboard, please
            contact the Office of Data Analytics and Archives at <a href="mailto:Info@OhioSoS.gov" target="_blank" 
            rel="noopener noreferrer">Info@OhioSoS.gov</a></p>
        </div>
        <div className="powerbi-embed-container">
          <iframe
            title="Ohio Election Results"
            width="100%"
            height={isMobile ? "350" : "500"}
            src={isMobile ? ELECTION_RESULTS_MOBILE_URL : ELECTION_RESULTS_DESKTOP_URL}
            frameBorder="0"
            allowFullScreen={true}
            style={{ border: '1px solid #cfd8dc' }}
          ></iframe>
        </div>
      </div>
    )
  },
  {
    label: 'Ohio Absentee and Early Voting Data',
    content: (isMobile) => (

      <div className="tab-flex">
        <div className="tab-text">
          <p>In 2024, the Secretary of State’s Office of Data Analytics and Archives custom-built
            the Absentee and Early Voting Data Dashboard to provide Ohioans with a new digital platform
            to help analyze voting trends and statistics more effectively during the early voting period.
            {' '} <a href="https://www.ohiosos.gov/office/media-center/categories/press-releases/2023-07-05"
            target="_blank" rel="noopener noreferrer">Thanks to the passage of the DATA Act</a>,
            Ohio can now provide detailed data dashboards to help
            users track daily absentee and early voting trends beginning with the November 5, 2024 General
            Election and continuing for all future elections. In addition to statewide data, 
            this dashboard displays county-level data from Ohio’s 88 county boards of elections and is 
            updated on a daily basis* during an early voting period.</p>
          <p>Detailed voter-level data showing absentee ballot requests and returns for the most current statewide election can be downloaded 
            {' '} <a href="https://publicfiles.ohiosos.gov/free/absentee_public_export/Absentee_Request_Report.txt" 
            target="_blank" rel="noopener noreferrer">here</a>. This dataset is collected daily from each county and will be 
            updated while early voting is ongoing. The file contains a timestamp indicating when it was published and shows 
            the status of reported requests and returns as of that day. To assist with comparative analysis, 
            the Office of Data Analytics and Archives has reconstructed the voter-level requests and returns file 
            from the 2024 November General Election with information collected at that point in time and can be downloaded 
            {' '} <a href="https://publicfiles.ohiosos.gov/free/absentee_public_export/Absentee_Request_Report_NOV2024.txt" 
            target="_blank" rel="noopener noreferrer">here</a>.</p>
          <p>Historical information is available separately via the dashboard. Demographic data from prior to 
            November 2024 is incomplete because it was not required in county reports.</p>
          <p>Note: Each county board of elections must populate and submit early voting and absentee
            data to the Secretary of State’s office pursuant to R.C. 3509.05(C)(4)(a). All data
            originates with the county boards, and questions about specific county data should be
            directed to the appropriate local boards. A full list of board contacts can be found
            {' '} <a href="https://www.ohiosos.gov/directories/county-boards-of-elections/" 
            target="_blank" rel="noopener noreferrer">here</a>.</p>
          <p>*If you have questions about the absentee data dashboard, please contact the office’s
            Office of Data Analytics and Archives at <a href="mailto:Info@OhioSoS.gov" target="_blank" 
            rel="noopener noreferrer">Info@OhioSoS.gov</a>.The absentee data dashboard is best viewed on a desktop computer.</p>
        </div>
        <div className="powerbi-embed-container">
          <iframe
            title="Ohio Absentee and Early Voting Data Dashboard"
            width="100%"
            height={isMobile ? "350" : "500"}
            src={isMobile ? ABSENTEE_MOBILE_URL : ABSENTEE_DESKTOP_URL}
            frameBorder="0"
            allowFullScreen={true}
            style={{ border: '1px solid #cfd8dc' }}
          ></iframe>
        </div>
      </div>
    )
  }
];

const ElectionData = () => {

  const [selectedYear, setSelectedYear] = useState(null);
  const { tab } = useParams();

  return (
    <div className="page-container election-results">
      <h2 className="vr-header">Election Dashboards</h2>
      <p className="intro">Welcome to Ohio’s Data Portal, your gateway to comprehensive and interactive information
        directly sourced from the Ohio Secretary of State's website. The Election Dashboard page allows you to
        delve into historical election data, providing insights across years with easy-to-navigate visualizations.
        Explore these comprehensive tools today to empower your participation in these vital areas.
      </p>

      {/* First Section */}
      <section className="section">
        <h3 className="section-title">Election Result Dashboards</h3>
        <TabbedContainer tabs={electionTabs} initialTab={tab === 'absentee' ? 1 : 0} />
      </section>

      {/* Second Section */}
      <section className="section">
        <h3 className="section-title">Local Election Results</h3>
        <div className="summary-row">
          <div className="summary-text">
            <p>
              Visit your county board of elections website for local election results.
              Find county through interactive map view or alphabetized list. Each county
              has a designated page to display its cumulative and precinct results.
            </p>
          </div>
          <a
            href="https://www.ohiosos.gov/directories/local-election-results/"
            target="_blank"
            rel="noopener noreferrer"
            className="standard-btn-link"
          >
            <button className="standard-btn registration">Explore Results</button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default ElectionData;
